import { FileRequest } from 'components/DocumentViewerModal/DocumentViewerModal'

import IFrameServer from './IFrameServer'

export default class DocumentViewerServer extends IFrameServer {
    constructor(target: Window, targetOrigin: string) {
        super('documentViewer', target, targetOrigin)
    }

    view(file: FileRequest) {
        window.documentViewer.view(file)
    }

    close() {
        window.documentViewer.close()
    }
}
